export default "__VITE_ASSET__CU8ObhA1__"